import React, { FC, ReactElement } from 'react';
import cn from 'classnames';

interface Props {
  isLarge?: boolean;
  isMedium?: boolean;
  disabled?: boolean;
  message: string | ReactElement;
  required?: boolean;
}

const Label: FC<Props> = ({
  isLarge = true,
  isMedium,
  disabled,
  message,
  required
}) => {
  const mergedClassName = cn(
    'mb-2 text-black',
    isLarge && 'fs-body-reg opacity-90',
    isMedium && 'fs-caption-reg opacity-90',
    disabled && 'opacity-30'
  );

  return (
    <div className={mergedClassName}>
      {message}
      {required && <span className="text-scarlet">*</span>}
    </div>
  );
};

export default Label;
